import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Heart, Clock, Unlock } from 'lucide-react';
import { PageBanner } from '../components/PageBanner';
export function EngagePage() {
  return <div className="pb-24" data-id="element-324">
      <PageBanner title="Engage with us" image="https://images.unsplash.com/photo-1506665531195-3566af2b4dfa?q=80&w=2070&auto=format&fit=crop" data-id="element-325" />

      {/* Our Principles Section */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-326">
        <div className="max-w-3xl mb-16" data-id="element-327">
          <h2 className="text-3xl font-serif text-brand-charcoal mb-6" data-id="element-328">
            Our principles
          </h2>
          <p className="text-xl text-brand-brown leading-relaxed" data-id="element-329">
            Every grant made as part of and managed by the Firetree Fund is
            built on three principles. These principles are not aspirational but
            the conditions under which we believe meaningful, lasting impact is
            possible.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-330">
          {/* Principle 1 */}
          <div className="bg-brand-cream p-8 rounded-2xl shadow-sm border border-brand-shape/50 flex flex-col items-center text-center" data-id="element-331">
            <div className="w-14 h-14 rounded-full bg-brand-card flex items-center justify-center mb-6 icon-hover" data-id="element-332">
              <Heart className="w-6 h-6 text-brand-gold" strokeWidth={1} data-id="element-333" />
            </div>
            <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-334">
              Relationship-based
            </h3>
            <p className="text-brand-brown leading-relaxed" data-id="element-335">
              Trust is the foundation of everything we do. We only fund
              organisations we know deeply, in geographies where we have
              extensive direct experience.
            </p>
          </div>

          {/* Principle 2 */}
          <div className="bg-brand-cream p-8 rounded-2xl shadow-sm border border-brand-shape/50 flex flex-col items-center text-center" data-id="element-336">
            <div className="w-14 h-14 rounded-full bg-brand-card flex items-center justify-center mb-6 icon-hover" data-id="element-337">
              <Clock className="w-6 h-6 text-brand-gold" strokeWidth={1} data-id="element-338" />
            </div>
            <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-339">
              Long-term
            </h3>
            <p className="text-brand-brown leading-relaxed" data-id="element-340">
              We support our partners for as long as they need it to achieve
              their goals. Short funding cycles consume the energy that leaders
              should be spending on their work.
            </p>
          </div>

          {/* Principle 3 */}
          <div className="bg-brand-cream p-8 rounded-2xl shadow-sm border border-brand-shape/50 flex flex-col items-center text-center" data-id="element-341">
            <div className="w-14 h-14 rounded-full bg-brand-card flex items-center justify-center mb-6 icon-hover" data-id="element-342">
              <Unlock className="w-6 h-6 text-brand-gold" strokeWidth={1} data-id="element-343" />
            </div>
            <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-344">
              Unrestricted
            </h3>
            <p className="text-brand-brown leading-relaxed" data-id="element-345">
              Once trust is established, we believe the organisation's
              leadership knows best where resources are most needed. We do not
              prescribe how funding is used.
            </p>
          </div>
        </div>
      </section>

      {/* Two Ways to Participate Section */}
      <section className="py-24 bg-brand-card/30 mt-12" data-id="element-346">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-347">
          <div className="max-w-3xl mb-16" data-id="element-348">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-349">
              Two ways to participate
            </h2>
            <p className="text-lg text-brand-brown leading-relaxed" data-id="element-350">
              Whether you want to give through a managed vehicle or engage
              directly with specific organisations, we can facilitate both. In
              either case, Firetree continues to advocate for unrestricted,
              long-term giving throughout the relationship.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-351">
            {/* Route 1 */}
            <div className="bg-brand-cream p-10 rounded-2xl shadow-sm border-t-4 border-t-brand-gold border-x border-b border-brand-shape/50" data-id="element-352">
              <span className="text-sm font-bold text-brand-gold tracking-widest uppercase mb-4 block" data-id="element-353">
                Route 1
              </span>
              <h3 className="text-2xl font-serif text-brand-charcoal mb-6" data-id="element-354">
                Through the Firetree Fund via ACF
              </h3>
              <p className="text-brand-brown leading-relaxed text-lg" data-id="element-355">
                Funds are housed with the Asia Community Foundation and managed
                by Firetree. We determine allocation across the portfolio based
                on ongoing engagement with each organisation, their current
                needs and potential to grow or deepen their work. Funders
                receive structured communication on allocation, and an annual
                supplementary report grounded in our visits and engagement.
              </p>
            </div>

            {/* Route 2 */}
            <div className="bg-brand-charcoal p-10 rounded-2xl shadow-sm border-t-4 border-t-brand-red" data-id="element-356">
              <span className="text-sm font-bold text-brand-red tracking-widest uppercase mb-4 block" data-id="element-357">
                Route 2
              </span>
              <h3 className="text-2xl font-serif text-brand-cream mb-6" data-id="element-358">
                Direct funding relationship
              </h3>
              <p className="text-brand-shape leading-relaxed text-lg" data-id="element-359">
                For funders who want to engage more closely with specific
                organisations or prefer to give to specific programmes or
                geography. Firetree facilitates introductions, visits and
                continued dialogue, and provides the context we have built over
                years of partnership. We stay available throughout and continue
                to advocate for the kind of funding these organisations need
                most.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center flex items-center justify-center" data-id="element-360">
        <div className="flex flex-col items-center space-y-8" data-id="element-361">
          <Link to="/contact" className="inline-flex items-center text-xl text-brand-charcoal font-serif hover:text-brand-red transition-colors group" data-id="element-362">
            Have questions? Get in touch
            <ArrowRight className="ml-3 w-6 h-6 transform group-hover:translate-x-1 transition-transform text-brand-red" data-id="element-363" />
          </Link>

          <a href="mailto:contact@firetree.org" className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-brand-cream bg-brand-red rounded-full hover:bg-brand-charcoal transition-colors shadow-sm hover:shadow-md" data-id="element-364">
            Get in touch
          </a>
        </div>
      </section>
    </div>;
}